import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { LoadingScreen } from "./components/LoadingScreen";
import Home from "./pages/Home";
import DomesticTours from "./pages/DomesticTours";
import InternationalTours from "./pages/InternationalTours";
import PackageDetail from "./pages/PackageDetail";
import Mice from "./pages/Mice";
import FarmersTours from "./pages/FarmersTours";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import SearchResults from "./pages/SearchResults";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminTours from "./pages/AdminTours";
import AdminBlogs from "./pages/AdminBlogs";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const SiteLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppButton />
  </>
);

function App() {
  const [showSplash, setShowSplash] = useState(() => !sessionStorage.getItem("ll_splash_seen"));

  const finishSplash = () => {
    sessionStorage.setItem("ll_splash_seen", "1");
    setShowSplash(false);
  };

  return (
    <BrowserRouter>
      {showSplash && <LoadingScreen onDone={finishSplash} />}
      <ScrollToTop />
      <Routes>
        {/* Admin (no marketing chrome) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/tours" element={<AdminTours />} />
        <Route path="/admin/blogs" element={<AdminBlogs />} />

        {/* Public site */}
        <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
        <Route path="/search" element={<SiteLayout><SearchResults /></SiteLayout>} />
        <Route path="/domestic-tours" element={<SiteLayout><DomesticTours /></SiteLayout>} />
        <Route path="/international-tours" element={<SiteLayout><InternationalTours /></SiteLayout>} />
        <Route path="/tour/:slug" element={<SiteLayout><PackageDetail /></SiteLayout>} />
        <Route path="/mice-events" element={<SiteLayout><Mice /></SiteLayout>} />
        <Route path="/farmers-study-tours" element={<SiteLayout><FarmersTours /></SiteLayout>} />
        <Route path="/blog" element={<SiteLayout><Blog /></SiteLayout>} />
        <Route path="/blog/:slug" element={<SiteLayout><BlogPost /></SiteLayout>} />
        <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
        <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
        <Route path="/faq" element={<SiteLayout><FAQ /></SiteLayout>} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
